<template>
  <div id="app">
    <router-view />
    <scroll-to-top />
  </div>
</template>

<script>

import scrollToTop from '@/components/scroll-to-top'

export default {
  name: 'app',
  components: {
    scrollToTop
  }
}
</script>
<style lang="scss">
body {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue